import FullCalendar from '@fullcalendar/react'
import { useEffect, useRef } from 'react'

import CalendarView from '../components/calendar/CalendarView'
import MoveBookingDialog from '../components/calendar/dialog/MoveBookingDialog'
import Toolbar from '../components/calendar/Toolbar'
import Loading from '../components/loading/Loading'
import { useCalendar } from '../hooks/useCalendar'
import { useCalendarUI } from '../hooks/useCalendarUI'


import { cn } from '@/lib/utils'

const Calendar = () => {
  const { resources, setDate } = useCalendar()
  const { fullscreen } = useCalendarUI()

  const calendarRef = useRef<FullCalendar | null>(null)

  useEffect(() => {
    const scrollingElement = document.scrollingElement as HTMLElement
    scrollingElement.style.overflow = fullscreen ? 'hidden' : ''
  }, [fullscreen])

  const changeDate = (date: Date | Date[] | string) => {
    if (!Array.isArray(date)) {
      calendarRef.current?.getApi().gotoDate(date as Date)
      setDate(date as Date)
    } else {
      calendarRef.current?.getApi().gotoDate(date[0])
      setDate(date[0])
    }
  }

  return (
    <div
      className={cn('px-8 py-4', {
        'fixed inset-0 overflow-auto bg-white': fullscreen,
      })}
    >
      <Loading loading={!resources} label="Kalender wird geladen...">
        <MoveBookingDialog />
        <Toolbar changeDate={changeDate} />
        <CalendarView changeDate={changeDate} calendarRef={calendarRef} />
      </Loading>
    </div>
  )
}

export default Calendar
